import { render, staticRenderFns } from "./xxgk-card.vue?vue&type=template&id=7fa47a20&"
import script from "./xxgk-card.vue?vue&type=script&lang=js&"
export * from "./xxgk-card.vue?vue&type=script&lang=js&"
import style0 from "./xxgk-card.vue?vue&type=style&index=0&id=7fa47a20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports